import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-event-quick-view-page',
  templateUrl: './company-event-quick-view-page.component.html',
  styleUrls: ['./company-event-quick-view-page.component.css']
})
export class CompanyEventQuickViewPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
